import { writable } from "svelte/store";

const NotepadStore = {
	meta: {
		visible: writable(false)
	}
};

export default NotepadStore;
